import { Badge } from '@/components/ui/badge.js';
import { cn } from '@/lib/tailwind-utils.js';
import type { CoachPool, CoachPoolFilters } from '@airreading/common/data';
import type { ReactNode } from 'react';

import { coachPoolFilterLabels } from './coach-pool-filter-labels.js';

interface CoachPoolFilterChipsProps {
  filters: CoachPoolFilters | CoachPool;
  className?: string;
  emptyState?: ReactNode;
}

export const CoachPoolFilterChips = ({ filters, className, emptyState = null }: CoachPoolFilterChipsProps) => {
  const labels = coachPoolFilterLabels(filters);
  if (labels.length === 0) {
    return emptyState;
  }

  return (
    <ul className={cn('flex flex-wrap gap-2', className)}>
      {labels.map((label) => (
        <li key={label}>
          <Badge variant="outline" className="bg-white font-normal">
            {label}
          </Badge>
        </li>
      ))}
    </ul>
  );
};
